//
//  GhaCsvDownloadList.tsx
//
//  isana.net,inc. Proprietary and Confidential
//
//  GHA CSVの作成済み一覧。Fitbit版（/csv-list, /csv-download）とは
//  独立した /gha-csv/list・/gha-csv/download を参照する。
//

import { ReactElement } from "react";
import { Container, CircularProgress } from "@mui/material";
import CsvDownloadTable from "./component/CsvDownloadTable";
import useCsvDownloadList from "./hooks/useCsvDownloadList";
import { getGhaCsvDownloadList, downloadGhaCsv } from "./network/ghaCsv/api";

const GhaCsvDownloadList = (): ReactElement => {
  const {
    displayedFiles,
    count,
    showProgress,
    rowsPerPage,
    page,
    handlePageChange,
  } = useCsvDownloadList(getGhaCsvDownloadList);

  return (
    <>
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {showProgress ? (
          <CircularProgress sx={{ m: 5 }} />
        ) : (
          <CsvDownloadTable
            files={displayedFiles}
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            hadlePageChange={handlePageChange}
            downloader={downloadGhaCsv}
          />
        )}
      </Container>
    </>
  );
};

export default GhaCsvDownloadList;
